import {gsap} from "gsap";
import {checkDeviceMobile} from "../../libs/helper";
import EmitEvent, {
    HT_RESIZE,
    HT_RESIZE_HEIGHT,
    HT_RESIZE_WIDTH,
    BEFORE_HT_RESIZE, PAGE_LOADED, PAGE_LEAVE
} from "../../libs/emit-event";

export class HtLayout {


    constructor() {
        this.idSetTimeoutWindowResize = null;
        this.onShowTimeout = false;
        this.callBeforeResize = false;
        this.init();
        this.timeoutWindowResize = this.timeoutWindowResize.bind(this);
        this.init = this.init.bind(this);
        this.getWin();
        this.bindingEvents();
    }

    init() {

        this.fix100VhOnPhone();
        this.contentFixed = [];
        this.contentFixed.push(document.querySelector('.header--site'));
        this.contentFixed.push(document.querySelector('#screen--content'));

        document.body.insertAdjacentHTML('beforeend', '<div id="layout-resize"></div>');
        this.layoutReize = document.querySelector('#layout-resize');

        this.bodyClass();
        this.getWin();
    }

    bodyClass() {
        if (checkDeviceMobile()) {
            document.body.classList.add('site__template-mobile');
            document.documentElement.classList.add('is-mobile');

        } else {
            document.body.classList.remove('site__template-mobile');
            document.documentElement.classList.remove('is-mobile');
        }
    }

    fix100VhOnPhone() {
        const vh = window.innerHeight * .01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    getWin() {
        this.winSize = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    calcWin() {
        this.calcWinSize = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    timeoutWindowResize() {

        this.onShowTimeout = false;
        this.bodyClass();

        if (this.winSize.width !== this.calcWinSize.width) {
            this.winSize.width = this.calcWinSize.width;
            //HTHelper.events.emit('htResizeWidth');
            EmitEvent.emit(HT_RESIZE_WIDTH);
        }
        if (this.winSize.height !== this.calcWinSize.height) {
            this.winSize.height = this.calcWinSize.height;
            //HTHelper.events.emit('htResizeHeight');
            EmitEvent.emit(HT_RESIZE_HEIGHT);
        }

        //HTHelper.events.emit('htResize');

        EmitEvent.emit(HT_RESIZE);
        this.callBeforeResize = false;

        gsap.to(this.layoutReize, {
            duration: .6,
            opacity: 0, ease: 'power3.inOut', onComplete: () => {
                this.layoutReize.style.zIndex = -1;
            }
        });
    }

    bindingEvents() {
        let _this = this;
        window.addEventListener('resize', function () {
            _this.calcWin();
            _this.fix100VhOnPhone();

            if (
                !checkDeviceMobile() ||
                (checkDeviceMobile() && _this.winSize.width !== _this.calcWinSize.width)
            ) {
                _this.winSize.width = _this.calcWinSize.width;
                if (!_this.onShowTimeout) {
                    _this.onShowTimeout = true;
                    _this.layoutReize.style.zIndex = 9999;
                    gsap.set(_this.layoutReize, {opacity: 1});
                }

                if (!_this.callBeforeResize) {
                    _this.callBeforeResize = true;
                    EmitEvent.emit(BEFORE_HT_RESIZE);
                }

                _this.idSetTimeoutWindowResize && clearTimeout(_this.idSetTimeoutWindowResize);
                _this.idSetTimeoutWindowResize = setTimeout(_this.timeoutWindowResize, 250);
            }
        });

        EmitEvent.on(PAGE_LOADED, this.bodyClass.bind(this));
        EmitEvent.on(PAGE_LEAVE, () => {
            if (checkDeviceMobile()) {
                window.scrollTo({left: 0, top: 0});
            }
        });
    }

    bodyOverHidden() {
        document.body.style.overflow = 'hidden';
        document.dispatchEvent(new CustomEvent('popup_opening'));
    }

    bodyOverVisible(timeout) {
        document.body.style.overflow = null;
        document.dispatchEvent(new CustomEvent('popup_closing'));
    }
}
